<template>
  <div class="photos-upload-component">
    <h5 class="photos-title">
      {{ $t('photos.label') }}
    </h5>
    <span class="photos-info">{{ $t('photos.restrictions') }}</span>
    <div class="upload-container">
      <template v-if="editing && value">
        <template v-for="(item, index) in mainValue">
          <div
            v-if="item.id"
            :key="item.id"
            class="image-item"
          >
            <el-button
              type="danger"
              icon="el-icon-delete"
              circle
              @click="removeFile(item)"
            />
            <template v-if="sortable && item.id">
              <button
                v-if="mainValue.length - 1 !== index"
                type="button"
                class="sort left"
                @click="handleSort(index, index + 1)"
              >
                <i class="el-icon-arrow-right" />
              </button>
              <button
                v-if="index !== 0"
                type="button"
                class="sort right"
                @click="handleSort(index, index - 1)"
              >
                <i class="el-icon-arrow-left" />
              </button>
            </template>
            <vue-load-image>
              <img
                slot="image"
                :src="item.url_view | resizeImage(140, 92)"
                :data-src="item.url_view | resizeImage(140, 92)"
              >
              <div
                slot="preloader"
                v-loading="true"
                class="img-loading"
              >
                {{ $t('Loading ....') }}
              </div>
              <div slot="error">
                {{ $t('Network error') }}
              </div>
            </vue-load-image>
          </div>
        </template>
      </template>
      <el-upload
        ref="adList"
        class="custom-image-wrapper"
        :limit="10"
        :multiple="true"
        :auto-upload="false"
        action="https://jsonplaceholder.typicode.com/posts/"
        list-type="picture-card"
        :on-preview="handlePictureCardPreview"
        :on-change="handleOnChange"
        :on-remove="handleRemove"
      >
        <template slot="trigger">
          <i class="icon-camera" />
        </template>
      </el-upload>
      <el-dialog :visible.sync="dialogVisible">
        <vue-load-image>
          <img
            slot="image"
            width="100%"
            :src="dialogImageUrl"
            :data-src="dialogImageUrl"
            alt=""
          >
          <div
            slot="preloader"
            v-loading="true"
            class="img-loading"
          >
            {{ $t('Loading ....') }}
          </div>
          <div slot="error">
            {{ $t('Network error') }}
          </div>
        </vue-load-image>
      </el-dialog>
    </div>
  </div>
</template>
<script>
export default {
  // eslint-disable-next-line vue/require-prop-types
  props: ['value', 'editing', 'sortable'],
  data() {
    return {
      fileList: [],
      dialogImageUrl: '',
      dialogVisible: false,
    };
  },
  computed: {
    mainValue() {
      const value = this.value || []
      return !this.sortable ? value : value.sort((item1, item2) => item1.sort - item2.sort)
    },

  },
  methods: {
    handleOnChange(file, fileArray) {
      if (this.$refs.adList && this.$refs.adList.uploadFiles) {
        this.draggableArray(this.$refs.adList.uploadFiles);
      }
      // eslint-disable-next-line no-console
      this.$emit('input', this.getUnifiedFiles(fileArray));
    },
    handleRemove(file, fileArray) {
      if (this.$refs.adList && this.$refs.adList.uploadFiles) {
        this.draggableArray(this.$refs.adList.uploadFiles);
      }
      this.$emit('input', this.getUnifiedFiles(fileArray));
    },
    handlePictureCardPreview(file) {
      // eslint-disable-next-line no-console
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    draggableArray(/* list */) {
      // console.log(list);
    },
    removeFile(val) {
      this.$emit('input', this.mainValue.filter(item => item.id !== val.id));
    },
    getUnifiedFiles(files) {
      return [
        ...files,
        ...this.mainValue.filter(item => !!item.id),
      ];
    },
    handleSort(sort1 = -1, sort2 = -1) {
      if (this.sortable) {
        const values = [...this.mainValue];
        try {
          [values[sort1], values[sort2]] = [values[sort2], values[sort1]]
          // eslint-disable-next-line no-empty
        } catch (e) { }
        this.$emit('input', values.map((item, index) => ({ ...item, sort: index }))
        );
      }
    },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/PhotosUpload.vue